/**
 * Description: Common functions used for all platform.
 * Version: 1.0.0
 * Last update: 2022/09/01
 * Author: Alejandro Zapata <azapata@3code.us>
 */
import moment from 'moment';
import { EventBus } from './../main';
import { RGBA } from "./../assets/js/map-rgb";

export let date = moment().format('YYYY-MM-DD HH:mm:ss');

export function numberPadding(num) {
    return ("0" + num).slice(-2);
}

export function getTimezone() {
    let d = new Date();
    let n = d.getTimezoneOffset();

    return (n / -60);
}

export function timeToDHMS(seconds, text = true) {
    let t = '';
    let d = Math.floor(seconds / (3600 * 24));
    let h = Math.floor(seconds % (3600 * 24) / 3600);
    let m = Math.floor(seconds % 3600 / 60);
    let s = Math.floor(seconds % 60);
	// console.log(`d=${d}, h=${h}, m=${m}, s=${s}`);
    t = d > 0 ? (d > 99 ? `+99d ` : `${d}d `) : '';
	t += h > 0 ? `${h}h ` : d > 0 ? '0h ' : '';
	t += m > 0 ? `${m}m ` : h > 0 ? '0m ' : '';
	t += s > 0 ? `${s}s` : m > 0 ? '0s' : '0s';

    return t;
}

export function timeToHM(seconds, min = false) {
    let t = '';
    let h = Math.floor(seconds / 3600);
    let m = Math.floor(seconds % 3600 / 60);

    t += h > 0 ? `${h}h ` : '';
    t += min ? (m > 0 || h > 0 ? `${m}m ` : '0m') : '';
    return t; // min ? `${h}h ${m}m` : `${h}h`;
}

export function dateToDatetime(date) {
    let d = date.replace(/(T|.(0-9){3}Z)/gi, ' ').trim();

    return moment(d).format('ll LT');
}

export function dateToDateOrText(date, text = false) {
    let d = date.replace(/(T|.(0-9){3}Z)/gi, ' ').trim();

    return text ? moment(d).utc().format('ll') : moment(d).utc().format('YYYY-MM-DD');
}

export function dateToTimeText(date) {
    let d = date.replace(/(T|.(0-9){3}Z)/gi, ' ').trim();

    return moment(d).utc().format('hh:mm A');
}

export function setCatchErrorAPI(from, error) {
    if (error.response) {
        console.error(`[ERR] ${from} - Code ${error.response.data.code}:`, error.response.data.message);
        if (error.response.data.code == 401) EventBus.$emit('tokenExpired', { expired: true });
    }
}

export function numberWithCommas(num, fix) {
    return num.toFixed(fix).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function msToTime(ms) {
	return moment(ms).utc().format('LTS');
}

export function convertDistance (value, decimals, distance) {
	let d = value > 0 ? (value * parseFloat(distance)) : value;

	return d.toFixed(decimals)
}

export function setHexToRgba(hex, opacity) {
	// console.warn(`@setHexToRgba(${hex}, ${opacity})`);
	let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)

	return result ? [
		parseInt(result[1], 16),
		parseInt(result[2], 16),
		parseInt(result[3], 16),
		opacity
	] : null
}

export function setTextToRgba(color, opacity) {
	// console.warn(`@setTextToRgba(${color}, ${opacity})`);
	let rgba = color ? RGBA[color.toLowerCase()] : RGBA['blue']
	rgba[3] = Math.floor(opacity * 255)

	return rgba
}

export function setIconName(size) {
	// console.warn(`@setIconName(${size})`);
	if (size === 0) {
		return '';
	}
	if (size < 10) {
		return `cluster-${size}`;
	}
	if (size < 100) {
		return `cluster-${Math.floor(size / 10)}0`;
	}
	return 'cluster-100';
}

export function getTimeZoneLocal(date, isUTC0 = true, dateT = true, format = true) {
	let dateTime = (dateT) ? "YYYY-MM-DD " : ''
	let amPm24 = (format) ? "HH:mm:ss" : 'hh:mm:ss A'
	if (isUTC0) {
		return new Date(date).toLocaleString('en-US');
		
	} else {
		return moment(date).utc().format(`${dateTime}${amPm24}`)
	}
}

export function getMomentDiff(lastTime, nowTime, diff = "", past = false) {
	if (past) {
		let a = moment(lastTime)
		let b = moment(nowTime)
		return b.diff(a, diff)
	} else {
		return moment(nowTime).diff(moment(lastTime), diff)
	}
}